import * as amplify from "./util/amplify.ts";
import * as Html from "./util/Html.ts";
import * as libLocation from "./lib/location.ts";
import * as handlebars_family from "./handlebars_family.js";
import * as progressbar from "./util/progressbar.ts";
import * as ga from "./tracking-googleanalytics.js";
import * as Screen from "./lib/Screen.js";
import $ from "./$.js";

const

  // Private constants

  // Page identifiers
  // sorted in alphabetic order of PHP file name
  URLs = {
    //this one is an external entry point DO NOT MODIFY
    FW2_INVITATION:"fw2_invitation.php",
    FW2_INVITATION_PROFILE:"fw2_invitation_profile.php",
    FW2_BLOCKINVITATION:"fw2_blockinvitation.php",
    FW2_BLOCKINVITATION_SUCCESS:"fw2_blockinvitation_success.php",
    FW2_SIGNIN:"fw2_signin.php",
    FW2_INVITATION_SUCCESS:"fw2_invitation_success.php",
    FW2_INVITATION_ERROR:"fw2_invitation_error.php",
    FW2_SIGNUP:"fw2_signup.php",
    FW2_SIGNUP_ALL:"fw2_signup_all.php",
    FW2_SIGNUP_FAMILY:"fw2_signup_family.php",
    FW2_PROMOCODE:"fw2_promocode.php",
    FW2_TERMS:"termsrecover.php",
    EMAIL_VALIDATE:"email_validate.php",
    LINK_SIGNUP:"fw2_signup.php",
    
    PREMIUM: "premium.php",
    CHANGE_PASSWORD: "change_password.php",
    CONTACTS: "contacts.php",
    EVENTS: "events.php",
    FEATURES: "features.php",
    FUNCTIONS: "functions.php",
    // alias for ACTIVITY
    ENTER_HOME: "home.php",
    DASHBOARD: "dashboard.php",
    ACTIVITY: "wall.php",
    MAP: "map.php",
    GEOHISTORY: "geohistory.php",
    SETTINGS: "settings.php",
    PASSWORD_FORGOTTEN: "password_forgotten.php",
  //this page PASSWORD_RESET is an external entry point be carefull no removing it
    PASSWORD_RESET: "password_reset.php",
    PASSWORD_RESET_SUCCESS: "password_reset_success.php",
  //this page ERROR_TOKEN is an external entry point be carefull no removing it
    ERROR_TOKEN: "error_token.php",
    PHOTO_ALBUMS: "photo_albums.php",
    PHOTOS: "photos.php",
    GALLERY:"gallery.php",
    IM: "im.php",
    TASKS:"tasks.php",
    FILER:"document.php",
    MEALPLANNER:"mealplanner.php",
    MEALPLANNER_NC:"mealplanner_nc.php",
    RECIPEBOX:"recipebox.php",
    RECIPEBOX_NC:"recipebox_nc.php",
    TIMETABLE_NC:"timetable_nc.php",
    TIMETABLE:"timetable.php",
    BUDGET:"budget.php",
    INVITATION_ALREADY_ACCEPTED:"invitation_already_accepted.php",
    EVENTS_OUTLOOKRETURN:"outlookreturn.php",
    FW2_PROMOCODE_VOUCHER:"voucher.php"
  },
  
  
  // the container for the insertion of each page
  container = $("#container"),

  // hash of URI -> array of callback functions for change of page events
  onPageCallbacksByUri :{[x: string]: Function[]} = {},

  // array of functions to cancel event subscriptions
  cancelSubscriptions :Function[] = [];

var
  PGBAR = progressbar.standard; 


//set URL accessible from mustache in order to use them
handlebars_family.mustacheContext.URL = URLs;


class Page{
  skin :string
  dependencies : ()=>Promise<any[]>
  data :any = {}
  startSequence : Function
  constructor(startSequence: Function,dependencies : ()=>Promise<any[]>,skin:string = "fw"){
    this.dependencies = dependencies
    this.skin = skin
    this.startSequence = startSequence
  }
  onParamChanged(){
    amplify.publish("handleParam")
  }
  async execute(){
    /*
      Event: pageUnload
      Published: before current page is unloaded

      Subscribe using INR.subscribe("pageUnload",callback)
      to run the callback only for current page.
    */
    amplify.publish("pageUnload");
    ga.page(libLocation.getPageName());
    window.analytics?.page();

    PGBAR.progress(0);
    if(Html.changeSkin(this.skin)){
      microNavAllowed = false;
      container.hide();
    }
    
    this.startSequence(async (initialData)=>{
      try{
        /*
          complete initial data with extra properties
        */
        var pageName = libLocation.getPageName();
        initialData.params = libLocation.getURLParams();
        initialData.screen = {small:Screen.isMobileView()}
        
        // deprecated
        // TODO: remove
        // TODO: access parameter values in "params" instead
        Object.assign(initialData, initialData.params);
        
        var 
          dependencies = await this.dependencies(),
          TPL = dependencies[0]?.default;

        if (TPL){
          var microNavContainer = document.querySelector('.fw-mainpane')
          if(microNavAllowed && microNavContainer){
            handlebars_family.mustacheoverride({'layout/layout_global':'{{>@partial-block}}'},()=>{
              Html.setHtml($(microNavContainer),TPL,initialData);
            })
          }else{
            Html.setHtml(container,TPL,initialData);
            microNavAllowed = true;
          }
          document.querySelectorAll('.fw-sidebar a').forEach((link)=>{
            if(link.getAttribute('href')===pageName){
              link.classList.add('selected');
            }else{
              link.classList.remove('selected');
            }
          })
        } else {
          container.html("");
        }
        cancelSubscriptions.forEach(func=>func())
        cancelSubscriptions.length = 0;
        onPageCallbacksByUri[pageName]?.forEach(func=>func())
        
        window.scrollTo(0,0); // scroll to top
        container.show();
      
      }catch(e){
        console.log(e);
        throw e;
      }finally{
        PGBAR.close();
        PGBAR = progressbar.none; //asked by ericv the 1st april 2014 
      }
      
    });
  }
}

/*
  Function: createPage(uris,startSequence,dependencies,skin): function
  Create the display function for given page

  When the current page URI changes to the given uri, the main template
  is rendered to replace the contents of the container element with id
  "container" in the page.

  The main template and associated partials are loaded dynamically and
  added to the cache in the mustache module before rendering.

  Parameters:
    uri - Array of url
    startSequence - function(callback): function, the sequence of actions
      required to initialize the page, ending with the action provided in
      callback argument:
        callback - function, the last action in the chain
    dependencies - stuff needed to display to page
    skin - css we want to use
*/
var microNavAllowed = false;

amplify.subscribe('familyScopeChange familyChange memberUpdated familyMemberSelected',()=>{microNavAllowed = false})
function createPage(uris :(string|string[]),startSequence :Function,dependencies :()=>Promise<any[]>,skin :string){
  var page = new Page(startSequence,dependencies,skin);
  
  (Array.isArray(uris)?uris:[uris]).forEach(function(uri :string){
    
    libLocation.register(uri,page);
  });
  
}

/*
  Function: subscribe(topic,callback)
  Subscribe to an event for the duration of the current page
  The subscription is cancelled automatically when the page changes.

  This method delegates the subscription to the amplify library.
  It is intended to be called instead of amplify.subscribe() inside a
  callback for INR.onPage(), to register the callback only for this page.

  Parameters:
    topic - string, the name of the event
    callback - function, callback to trigger until the end of current page
*/
function subscribe(topic :string,callback :Function){
  amplify.subscribe(topic,callback);
  cancelSubscriptions.push(function(){
    amplify.unsubscribe(topic,callback);
  });
}

function onPage(uri : string,callback :Function){
  if (onPageCallbacksByUri[uri] ===undefined ){
    onPageCallbacksByUri[uri] = [];
  }
  onPageCallbacksByUri[uri].push(callback);  
}

libLocation.setDefaultUrl(URLs.ENTER_HOME);
libLocation.setPageDefinitionLoader(async function(url :string){
  await import('./pageset_connected.ts');
});

var resizeTimeout;

$(window).on('resize',function(){
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function(){
    amplify.publish('resize')
  },200);
});
amplify.subscribe('refresh',libLocation.refresh);
  
export{
  URLs as URL,
  createPage,
  onPage,
  subscribe
}